import { Stack } from "@mui/material";
import { ProductInventoryPermission } from "commons/enum/permission";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { AddProductGoodsIssue } from "../add-goods-issue/add-goods-issue";
import { UpdateProductGoodsIssue } from "../update-goods-issue/update-goods-issue";
import { ProductGoodsIssueTable } from "./product-goods-issue-table";

export const ProductGoodsIssueList = observer(() => {
  const {
    productInventoryManagement: {
      productGoodsIssueStore: {
        setProp,
        pagination,
        getProductGoodsIssue,
        openNew,
        openEdit,
        queryParams: {
          dateRangeFilter: {
            fromAsDayJs,
            toAsDayJs,
            setProp: setDateRangeProps,
          },
          dealingName,
          code,
          name,
          barcode,
          setProp: setQueryParamProp,
        },
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getProductGoodsIssue();
  }, [getProductGoodsIssue, pagination]);

  const fromDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("from", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const toDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("to", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="start"
        gap={4}
      >
        <Stack direction="column" gap={2}>
          <DateRange
            label={"Ngày xuất"}
            fromDate={fromAsDayJs}
            toDate={toAsDayJs}
            onFromDateChanged={fromDateChangedHandler}
            onToDateChanged={toDateChangedHandler}
          ></DateRange>
          <PageFilterContainer>
            <XSearchTextField
              label="Tên giao dịch"
              value={dealingName}
              onChange={(e) =>
                setQueryParamProp("dealingName", e.currentTarget.value)
              }
            ></XSearchTextField>
            <XSearchTextField
              label="Tên hàng"
              value={name}
              onChange={(e) => setQueryParamProp("name", e.currentTarget.value)}
            ></XSearchTextField>
            <XSearchTextField
              label="Mã hàng"
              value={code}
              onChange={(e) => setQueryParamProp("code", e.currentTarget.value)}
            ></XSearchTextField>
            <XSearchTextField
              label="Mã barcode"
              value={barcode}
              onChange={(e) =>
                setQueryParamProp("barcode", e.currentTarget.value)
              }
            ></XSearchTextField>
            <SearchButton asyncAction={onSearch}></SearchButton>
          </PageFilterContainer>
        </Stack>
        <Stack direction="row" justifyContent="end" flexShrink={0}>
          <AddButton
            accessPermission={[ProductInventoryPermission.ExportCreate]}
            onClick={() => {
              setProp("openNew", true);
            }}
          >
            Thêm xuất kho
          </AddButton>
        </Stack>
      </Stack>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <ProductGoodsIssueTable></ProductGoodsIssueTable>
      </PageContentContainer>

      <>
        {openNew && <AddProductGoodsIssue></AddProductGoodsIssue>}
        {openEdit && <UpdateProductGoodsIssue></UpdateProductGoodsIssue>}
      </>
    </>
  );
});
